module.exports = __webpack_public_path__ + "media/img/stalowe@3x-22719420.svg";